import * as React from 'react';
export const IcRoRepair = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.43 17.25a.45.45 0 00-.18-.18.5.5 0 00-.68.17l-.89 1.5c-.15.29-.21.617-.17.94.048.323.195.623.42.86.142.139.308.25.49.33a1.46 1.46 0 001.16 0 1.51 1.51 0 00.49-.33 1.62 1.62 0 00.42-.87 1.57 1.57 0 00-.18-.95l-.88-1.47zM21 3h-4a3 3 0 00-3 3v1h-3V6a3 3 0 00-3-3H6a3 3 0 00-3 3v5a3 3 0 002 2.82V15a1 1 0 001 1h2a1 1 0 001-1v-1.18A3 3 0 0011 11h2v1a1 1 0 001 1h2a1 1 0 001-1v-1h2a1 1 0 002 0V7a1 1 0 00-2 0h-3V6a1 1 0 011-1h4a1 1 0 100-2z'
      fill='currentColor'
    />
  </svg>
);
